import React from 'react';
import QRCode from 'qrcode-react';

const QrCode = ({text}) => {
    return <QRCode value={text} size={250} />
}

export default QrCode;